(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NskyNavigate", [], factory);
	else if(typeof exports === 'object')
		exports["NskyNavigate"] = factory();
	else
		root["NskyNavigate"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/